import EvidenceOfInsurability from './evidence-of-insurability';
import TotalAnnualPremium from './total-annual-premium';
import { selectActiveRateTab } from '../../../../../../features/actuarial/rates-slice';
import { useSelector } from 'react-redux';

export default function ProposalComputationEoITAP() {

    const activeTab = useSelector(selectActiveRateTab);
    
    if(activeTab !== "eoi") return null

    return (
        <div className="flex h-full min-h-0 flex-col overflow-hidden ">
            <div className='flex-1 min-h-0 overflow-y-auto py-2 mb-1'>
                <div className='w-full space-y-3'>
                    <TotalAnnualPremium/>
                    <div className='col-span-1'>
                        <EvidenceOfInsurability customStyle={'grid-col-1'} />
                    </div>
                </div>
            </div>
        </div>
    )
}